import { frontendURL } from '../../../helper/URLHelper';
import FunnelView from './pages/FunnelView.vue';

const meta = { permissions: ['administrator', 'agent'] };
export const routes = [
  {
    path: frontendURL('accounts/:accountId/funnel'),
    name: 'funnel_index',
    component: FunnelView,
    meta,
  },
];
